export const en = {
  // Navigation
  nav: {
    home: 'Home',
    services: 'Services',
    about: 'About',
    portfolio: 'Portfolio',
    contact: 'Contact',
    getStarted: 'Get Started',
  },

  // Hero Section
  hero: {
    tagline: 'CREATIVE AGENCY',
    title: 'Innovation Meets',
    titleHighlight: 'Inspiration',
    subtitle: 'We craft bold, unforgettable marketing experiences that elevate your brand and captivate your audience.',
    cta: 'Start Your Project',
    watchVideo: 'Watch Video',
    servicesButton: 'Explore Services',
    scrollText: 'Scroll to explore',
  },

  // Services Section
  services: {
    tag: 'WHAT WE DO',
    title: 'Our',
    titleHighlight: 'Services',
    subtitle: 'Comprehensive creative solutions tailored to elevate your brand and achieve your business goals.',
    
    items: [
      {
        icon: '🎨',
        title: 'Branding',
        description: 'Create a memorable brand identity that resonates with your target audience.',
      },
      {
        icon: '📢',
        title: 'Advertising',
        description: 'Strategic campaigns that capture attention and drive measurable results.',
      },
      {
        icon: '✏️',
        title: 'Design',
        description: 'Stunning visual designs that communicate your brand story effectively.',
      },
      {
        icon: '🌐',
        title: 'Digital Marketing',
        description: 'Data-driven strategies to maximize your online presence and ROI.',
      },
      {
        icon: '🎬',
        title: 'Filming',
        description: 'Professional video production that brings your brand narrative to life.',
      },
      {
        icon: '💻',
        title: 'Website Development',
        description: 'Custom, responsive websites that deliver exceptional user experiences.',
      },
      {
        icon: '📱',
        title: 'Mobile Apps',
        description: 'Intuitive mobile applications designed for iOS and Android platforms.',
      },
    ],
  },

  // About Section
  about: {
    tag: 'ABOUT US',
    title: 'Why Choose',
    titleHighlight: 'Orvin',
    subtitle: 'We are a team of passionate creatives dedicated to transforming brands through innovative marketing solutions.',
    
    stats: [
      { number: 78, label: 'Projects Completed', suffix: '+' },
      { number: 98, label: 'Client Satisfaction', suffix: '%' },
      { number: 4, label: 'Team Members', suffix: '+' },
      { number: 5, label: 'Years Experience', suffix: '' },
    ],

    features: [
      {
        title: 'Creative Excellence',
        description: 'Award-winning creative team with proven track record.',
      },
      {
        title: 'Strategic Approach',
        description: 'Data-driven strategies that deliver measurable results.',
      },
      {
        title: 'Client-Focused',
        description: 'Your success is our priority. We listen, adapt, and deliver.',
      },
    ],
  },

  // Portfolio Section
  portfolio: {
    tag: 'OUR WORK',
    title: 'Featured',
    titleHighlight: 'Projects',
    subtitle: 'Explore our portfolio of successful projects that showcase our creativity, expertise, and commitment to excellence.',
    close:'Close',
    categories: {
      all: 'All Projects',
      branding: 'Branding',
      webDesign: 'Web Design',
      marketing: 'Marketing',
      appDesign: 'App Design',
      video: 'Video',
      design: 'Design',
    },

    viewProject: 'View Project',
    featured: 'Featured',
    client: 'Client',
    year: 'Year',
    viewLive: 'View Live Project',
  },

  // Contact Section
  contact: {
    tag: 'GET IN TOUCH',
    title: "Let's Create Something",
    titleHighlight: 'Amazing',
    subtitle: "Ready to take your brand to the next level? Let's start a conversation.",
    
    form: {
      namePlaceholder: 'Your Name *',
      emailPlaceholder: 'Your Email *',
      subjectPlaceholder: 'Subject (Optional)',
      messagePlaceholder: 'Tell us about your project... *',
      sendButton: 'Send Message 🚀',
      sending: 'Sending...',
      requiredNote: '* Required fields | We\'ll respond within 24 hours',
    },

    info: {
      email: 'Email',
      phone: 'Phone',
      location: 'Location',
    },

    success: {
      title: 'Message Sent Successfully! 🎉',
      message: "We've received your message and sent a confirmation to your email. Our team will get back to you within 24 hours!",
    },

    errors: {
      nameRequired: 'Name must be at least 2 characters',
      emailInvalid: 'Please enter a valid email address',
      messageRequired: 'Message must be at least 10 characters',
      subjectTooLong: 'Subject must be less than 100 characters',
      fixErrors: 'Please fix the errors in the form',
      sendFailed: 'Something went wrong. Please try again.',
    },
  },

  // Footer
  footer: {
    tagline: 'Innovation meets inspiration',
    about: 'We are a creative agency dedicated to crafting bold, unforgettable marketing experiences.',
    quickLinks: 'Quick Links',
    services: 'Services',
    followUs: 'Follow Us',
    copyright: '© 2026 Orvin Creative Agency. All rights reserved.',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    craftedWith: 'Crafted with passion',
  },
};
